import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import content from '../static/content.json';

const FormPage = () => {
  const localStr = useLocation();
  const staticText = content.FormPage;

  const [formData, setFormData] = useState({
    form_notes: "",
    consent: false, // New consent checkbox for ID and Phone fields
    id: "",
    phone: "",
    form_date: "",
    form_time: "",
    form_location: "",
    form_photo: null,
  });

  const isDemoMode = localStorage.getItem("userId") === "demo";
  const isEditMode = localStorage.getItem("isEditMode") === "true";
  const currentTimeRef = useRef(null);

  useEffect(() => {
    if (!isEditMode) {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");

      setFormData((prevFormData) => ({
        ...prevFormData,
        form_date: `${year}-${month}-${day}`,
        form_time: `${hours}:${minutes}`,
      }));

      currentTimeRef.current = `${hours}:${minutes}`;
    }
  }, [isEditMode]);

  // useEffect(() => {
  //   if (localStr.state && localStr.state.issueInfo) {
  //     setFormData(localStr.state.issueInfo);
  //   }
  // }, [localStr.state]);

    useEffect(() => {
      
      if (isDemoMode && isEditMode) {
        // Retrieve saved data from local storage in demo mode

        const savedData = JSON.parse(localStorage.getItem("issueInfoDemo"));
        if (savedData) {
          setFormData(savedData);
        }
      } else if (localStr.state && localStr.state.issueInfo) {
        setFormData(localStr.state.issueInfo);
      }
    }, [localStr.state, isDemoMode]);

  const caseId = localStorage.getItem("caseId");
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const apiToken = localStorage.getItem("apiToken");

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [isPhotoFullSize, setIsPhotoFullSize] = useState(false);

  const handleSubmitIssue = async (e) => {
    e.preventDefault();

    const formDataObject = {
      user_id: userId,
      api_token: apiToken,
      software: "better-retter",
      form_date: formData.form_date,
      form_time: formData.form_time,
      form_note: formData.form_note,
      form_location: formData.form_location,
      consent: formData.consent,
    };

    if (isDemoMode) {
      // Save data to local storage in demo mode
      localStorage.setItem("issueInfoDemo", JSON.stringify(formDataObject));
      alert("Data saved in demo mode.");
      localStorage.removeItem("isEditMode");
      localStorage.setItem("caseId", "demo");

      navigate("/overview");
    } else {
      try {
        const response = await axios.post(
          `https://app.better-retter.de/api/patient/create/${caseId}`,
          { ...formDataObject }
        );

        if (response.data.success === true) {
          localStorage.setItem("issueInfo" + userId, JSON.stringify(formDataObject));
          localStorage.removeItem("isEditMode");

          navigate("/overview");
        } else {
          alert("Submit failed");
        }
      } catch (error) {
        console.error("Submit error:", error);
        alert("An error occurred during submitting. Please try again.");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleConsentChange = (e) => {
    setFormData({
      ...formData,
      consent: e.target.checked,
    });
  };

  // const handleStartCamera = () => {
  //   setIsCameraOn(true);
  //   navigator.mediaDevices
  //     .getUserMedia({ video: true })
  //     .then((stream) => {
  //       videoRef.current.srcObject = stream;
  //     })
  //     .catch((err) => console.error("Error accessing camera:", err));
  // };

  // const handleCapturePhoto = () => {
  //   const video = videoRef.current;
  //   const canvas = canvasRef.current;
  //   const context = canvas.getContext("2d");
  //   context.drawImage(video, 0, 0, canvas.width, canvas.height);

  //   const photoData = canvas.toDataURL("image/png");
  //   setFormData({
  //     ...formData,
  //     form_photo: photoData,
  //   });

  //   const stream = video.srcObject;
  //   const tracks = stream.getTracks();
  //   tracks.forEach((track) => track.stop());
  //   setIsCameraOn(false);
  // };

return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f0f0f0",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        }}
      >
    <h2>{staticText.TitleOnTop}</h2>
    <form onSubmit={handleSubmitIssue}>
      {/* Date Input */}
          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="date">{staticText.DateInputText}</label>
        <input
          type="date"
          id="date"
          name="form_date"
          value={formData.form_date}
          onChange={handleChange}
              style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
            />
          </div>

          {/* Time Input 
          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="time">{staticText.TimeInputText}</label>
            <input
              type="time"
              id="time"
              name="form_time"
              value={formData.form_time || currentTimeRef.current}
              onChange={handleChange}
              style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
            />
          </div>*/}

          {/* Location Input 
          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="location">{staticText.LocationInputText}</label>
            <input
              type="text"
              id="location"
              name="form_location"
              value={formData.form_location}
              onChange={handleChange}
              style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
              placeholder="Optional"
        />
      </div>

      {/* Notes Input */}
          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="Notes">{staticText.NoteInputText}</label>
        <textarea
          id="Notes"
          name="form_note"
          value={formData.form_note}
          onChange={handleChange}
              style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
              placeholder= {staticText.NoPrivateInfoMessage}
        />
      </div>

      {/* Consent Box */}
          <div
            style={{
              marginBottom: "15px",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              backgroundColor: "#f9f9f9",
            }}
          >
        <label>
          <input
            type="checkbox"
            checked={formData.consent}
            onChange={handleConsentChange}
                style={{ marginRight: '8px' }}
          />
          {staticText.ConsentDeclarationText}
        </label>
        {formData.consent && (
          <>
                <div style={{ marginTop: "10px" }}>
                  <label htmlFor="id">{staticText.IdOfRescuerFieldText}</label>
              <input
                type="text"
                id="id"
                name="id"
                value={formData.id}
                onChange={handleChange}
                    style={{
                      width: "100%",
                      padding: "8px",
                      boxSizing: "border-box",
                    }}
                placeholder="Optional"
              />
            </div>
                <div style={{ marginTop: "10px" }}>
                  <label htmlFor="phone">{staticText.TelephoneNumberOfRescuerText}</label>
              <input
                type="text"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                    style={{
                      width: "100%",
                      padding: "8px",
                      boxSizing: "border-box",
                    }}
                placeholder="Optional"
              />
            </div>
          </>
        )}
      </div>

          <button
            type="submit"
            style={{
              padding: "10px 15px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
        {staticText.SendButtonText}
      </button>
    </form>
      </div>
  </div>
);
};

export default FormPage;
